import {
  Box,
  Typography,
  Card,
  CardContent,
  CardMedia,
  useTheme,
  Button,
} from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// Import all images
import KayakDesktopSm from "../../../assets/images/slider/dashboard/kayak_mobile.png";
import KayakDesktop from "../../../assets/images/slider/dashboard/kayak-mobile.png";
import FiftyMobile from "../../../assets/images/slider/dashboard/fifty_mobile.jpg";
import FiftyDesktop from "../../../assets/images/slider/dashboard/fifty_desktop.jpg";
import NoDepositDesktop from "../../../assets/images/slider/dashboard/nodeposit_desktop.jpg";
import NoDepositMobile from "../../../assets/images/slider/dashboard/nodeposit_mobile.png";
import StartSmartDesktop from "../../../assets/images/slider/dashboard/start-smart-desktop.png";
import StartSmartMobile from "../../../assets/images/slider/dashboard/start-smart-mobile.png";
import JetStayDesktop from "../../../assets/images/slider/dashboard/jet-stay-desktop.png";
import JetStayMobile from "../../../assets/images/slider/dashboard/jet-stay-mobile.png";
import FlexibleStaysDesktop from "../../../assets/images/slider/dashboard/flexible-stays-desktop.png";
import FlexibleStaysMobile from "../../../assets/images/slider/dashboard/flexible-stays-mobile.png";
import FiveStartFiveYearMobile from "../../../assets/images/slider/dashboard/five-star_five-year_mobile.png";
import FiveStartFiveYearDesktop from "../../../assets/images/slider/dashboard/five-star_five-year_desktop.png";
import ShareTheRoomMobile from "../../../assets/images/slider/dashboard/share-the-room-mobile.png";
import ShareTheRoomDesktop from "../../../assets/images/slider/dashboard/share-the-room-desktop.png";
import XmaxGiftMobile from "../../../assets/images/slider/dashboard/xmas_gift_mobile.jpg";
import XmaxGiftDesktop from "../../../assets/images/slider/dashboard/xmas_gift_desktop.jpg";
import BlackFridayMobile from "../../../assets/images/slider/dashboard/black_friday_mobile.png";
import BlackFridayDesktop from "../../../assets/images/slider/dashboard/black_friday_desktop.png";
import SoundonMobile from "../../../assets/images/slider/dashboard/soundon_mobile.png";
import SoundonDesktop from "../../../assets/images/slider/dashboard/soundon_desktop.png";
import AnyInternsMobile from "../../../assets/images/slider/dashboard/any_interns_mobile.png";
import AnyInternsDesktop from "../../../assets/images/slider/dashboard/any_interns_desktop.png";
import RiseShineMobile from "../../../assets/images/slider/dashboard/rise-shine-mobile.jpg";
import RiseShineDesktop from "../../../assets/images/slider/dashboard/rise-shine-desktop.jpg";

import KingsAwardsMobile from "../../../assets/images/slider/dashboard/kings-awards-mobile.jpg";
import KingsAwardsDesktop from "../../../assets/images/slider/dashboard/kings-awards-desktop.jpg";

import BookGapMobile from "../../../assets/images/slider/dashboard/book-gap-mobile.png";
import BookGapDesktop from "../../../assets/images/slider/dashboard/book-gap-desktop.png";

import DmcEnterLondonMobile from "../../../assets/images/slider/dashboard/dmc-enter-london-mobile.jpg";
import DmcEnterLondonDesktop from "../../../assets/images/slider/dashboard/dmc-enter-london-desktop.jpg";

import SpecialOfferMobile from "../../../assets/images/slider/dashboard/special_offer_mobile.png";
import SpecialOfferDesktop from "../../../assets/images/slider/dashboard/special-offer-desktop.png";

import LondonViewImg from "../../../assets/images/london-view.jpg";
// Import badges
import SilverBadge from "../../../assets/images/badges/silver.svg";
import PlatinumBadge from "../../../assets/images/badges/platinum.svg";
import GoldBadge from "../../../assets/images/badges/gold.svg";
import BronzeBadge from "../../../assets/images/badges/bronze.svg";

import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

// Slide types
type SlideType = "image" | "video" | "image-link";

interface SlideData {
  id: string;
  type: SlideType;
  title?: string;
  description?: string;
  images: {
    mobile: string,
    desktop: string,
  };
  link?: {
    url: string,
    target?: "_blank" | "_self",
  };
  video?: {
    embedUrl: string,
    title?: string,
  };
  hasGradient?: boolean;
}

// Dynamic slides configuration
const slidesData: SlideData[] = [
  {
    id: "special-offer",
    type: "image-link",
    title: "Special Offer",
    images: {
      mobile: SpecialOfferMobile,
      desktop: SpecialOfferDesktop,
    },
    link: {
      // url: "#",
      // target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "dmc-enter-london",
    type: "image-link",
    title: "Enter London",
    images: {
      mobile: DmcEnterLondonMobile,
      desktop: DmcEnterLondonDesktop,
    },
    link: {
      url: "https://londonist.co.uk/landing-student/enter-london",
      target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "book-the-gap",
    type: "image-link",
    title: "Book the Gap",
    images: {
      mobile: BookGapMobile,
      desktop: BookGapDesktop,
    },
    link: {
      url: "https://landing.londonist.co.uk/book-the-gap",
      target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "kings-award-for-enterprise",
    type: "image-link",
    title: "Kings Award for Enterprise",
    images: {
      mobile: KingsAwardsMobile,
      desktop: KingsAwardsDesktop,
    },
    link: {
      url: "https://londonist.co.uk/news/londonist-dmc-receives-the-2025-kings-award-for-enterprise",
      target: "_blank",
    },
    hasGradient: true,
  },
  // {
  //   id: "any-interns",
  //   type: "image-link",
  //   title: "Any Interns",
  //   images: {
  //     mobile: AnyInternsMobile,
  //     desktop: AnyInternsDesktop,
  //   },
  //   link: {
  //     url: "https://londonist.co.uk/any-interns",
  //     target: "_blank",
  //   },
  //   hasGradient: true,
  // },
  {
    id: "soundon",
    type: "image-link",
    title: "Sound On",
    images: {
      mobile: SoundonMobile,
      desktop: SoundonDesktop,
    },
    link: {
      url: "#",
      target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "rise-shine",
    type: "image-link",
    title: "Rise and Shine",
    images: {
      mobile: RiseShineMobile,
      desktop: RiseShineDesktop,
    },
    link: {
      url: "https://londonist.co.uk/blogs/rise-and-shine-londonist-family",
      target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "flexible-stays",
    type: "image",
    title: "Flexible Stays",
    images: {
      mobile: FlexibleStaysMobile,
      desktop: FlexibleStaysDesktop,
    },
    hasGradient: true,
  },
  {
    id: "kayak",
    type: "image-link",
    title: "Kayak",
    images: {
      mobile: KayakDesktopSm,
      desktop: KayakDesktop,
    },
    link: {
      url: "https://www.kayak.co.uk/?utm_source=tradetracker&utm_medium=affiliate&utm_campaign=472424&utm_content=32925",
      target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "youtube-video",
    type: "video",
    title: "YouTube Video",
    images: {
      mobile: "",
      desktop: "",
    },
    video: {
      embedUrl: "https://www.youtube.com/embed/t_jmqnFsKkw?si=IOpd7I-jqlscYcTT",
      title: "Embedded YouTube Video",
    },
    hasGradient: true,
  },
  // {
  //   id: "fifty",
  //   type: "image-link",
  //   title: "Fifty",
  //   images: {
  //     mobile: FiftyMobile,
  //     desktop: FiftyDesktop,
  //   },
  //   link: {
  //     url: "#",
  //     target: "_blank",
  //   },
  //   hasGradient: true,
  // },
  // {
  //   id: "no-deposit",
  //   type: "image",
  //   title: "No Deposit",
  //   images: {
  //     mobile: NoDepositMobile,
  //     desktop: NoDepositDesktop,
  //   },
  //   hasGradient: true,
  // },
  // {
  //   id: "start-smart",
  //   type: "image-link",
  //   title: "Start Smart",
  //   images: {
  //     mobile: StartSmartMobile,
  //     desktop: StartSmartDesktop,
  //   },
  //   link: {
  //     url: "#",
  //     target: "_blank",
  //   },
  //   hasGradient: true,
  // },
  // {
  //   id: "jet-stay",
  //   type: "image",
  //   title: "Jet Stay",
  //   images: {
  //     mobile: JetStayMobile,
  //     desktop: JetStayDesktop,
  //   },
  //   hasGradient: true,
  // },
  // {
  //   id: "five-star-five-year",
  //   type: "image-link",
  //   title: "Five Star Five Year",
  //   images: {
  //     mobile: FiveStartFiveYearMobile,
  //     desktop: FiveStartFiveYearDesktop,
  //   },
  //   link: {
  //     url: "#",
  //     target: "_blank",
  //   },
  //   hasGradient: true,
  // },
  // {
  //   id: "share-the-room",
  //   type: "image",
  //   title: "Share The Room",
  //   images: {
  //     mobile: ShareTheRoomMobile,
  //     desktop: ShareTheRoomDesktop,
  //   },
  //   hasGradient: true,
  // },
  // {
  //   id: "xmas-gift",
  //   type: "image-link",
  //   title: "Christmas Gift",
  //   images: {
  //     mobile: XmaxGiftMobile,
  //     desktop: XmaxGiftDesktop,
  //   },
  //   link: {
  //     url: "#",
  //     target: "_blank",
  //   },
  //   hasGradient: true,
  // },
  // {
  //   id: "black-friday",
  //   type: "image",
  //   title: "Black Friday",
  //   images: {
  //     mobile: BlackFridayMobile,
  //     desktop: BlackFridayDesktop,
  //   },
  //   hasGradient: true,
  // },
];

const SliderTopArea = () => {
  const { t, i18n } = useTranslation();

  const lightMode = useSelector((state: any) => state.mode.lightMode);
  const profile = useSelector((state: any) => state.profile);

  const theme = useTheme();

  // Function to get badge image based on profile
  const getBadgeImage = () => {
    const badge = profile?.profile?.badge?.toLowerCase();
    if (badge?.includes("gold")) return GoldBadge;
    if (badge?.includes("silver")) return SilverBadge;
    if (badge?.includes("platinum")) return PlatinumBadge;
    if (badge?.includes("bronze")) return BronzeBadge;
    return null;
  };

  // Function to render slide content based on type
  const renderSlideContent = (slide: SlideData) => {
    const gradientOverlay = slide.hasGradient
      ? {
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: `linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 70%) 100%)`,
          zIndex: 1,
          pointerEvents: "none",
          borderRadius: ".5rem",
        },
      }
      : {};

    const baseBoxStyles = {
      position: "relative",
      width: "100%",
      height: "100%",
      ...gradientOverlay,
    };

    switch (slide.type) {
      case "video":
        return (
          <Box sx={baseBoxStyles}>
            <Card
              sx={{
                height: "100%",
                width: "100%",
                borderRadius: ".5rem",
                position: "relative",
                zIndex: 0,
              }}
            >
              <CardMedia
                component="iframe"
                style={{ borderRadius: ".5rem" }}
                height="100%"
                src={slide.video?.embedUrl}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                title={slide.video?.title || slide.title}
              />
            </Card>
          </Box>
        );

      case "image-link":
        return (
          <Box sx={baseBoxStyles}>
            <Link
              to={slide.link?.url || "#"}
              target={slide.link?.target || "_self"}
              style={{
                width: "100%",
                height: "100%",
                position: "relative",
                zIndex: 0,
              }}
            >
              <img
                src={
                  window?.innerWidth < 768
                    ? slide.images.mobile
                    : slide.images.desktop
                }
                style={{
                  borderRadius: ".5rem",
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
                alt={slide.title || ""}
              />
            </Link>
          </Box>
        );

      case "image":
      default:
        return (
          <Box sx={baseBoxStyles}>
            <Box
              style={{
                width: "100%",
                height: "100%",
                position: "relative",
                zIndex: 0,
              }}
            >
              <img
                src={
                  window?.innerWidth < 768
                    ? slide.images.mobile
                    : slide.images.desktop
                }
                style={{
                  borderRadius: ".5rem",
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
                alt={slide.title || ""}
              />
            </Box>
          </Box>
        );
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", lg: "row" },
        maxHeight: { xs: "auto", lg: 400 },
        gap: 2,
        p: 0,
        fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
      }}
    >

      {/* Left Welcome Section */}
      <Card
        sx={{
          flex: 2,
          backgroundImage: `linear-gradient(to right, rgba(20, 26, 33, 0.88) 0%, #305890 75%), url(${LondonViewImg})`,
          backgroundImage: `linear-gradient(to right, rgba(20, 26, 33, 0.88) 0%, #305890 95%),url(${LondonViewImg})`,

          backgroundPosition: "center",
          borderRadius: "20px",
          border: "none",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
          position: "relative",
          overflow: "hidden",
        }}
      >

        {/*   <Box display={"flex"}>
          <Button variant="contained" onClick={() => {
            // Warning/Delete confirmation
            Swal.fire({
              icon: 'warning',
              title: 'Are you sure?',
              text: "You're about to delete your account. This action cannot be undone.",
              showCancelButton: true,
              confirmButtonText: 'Yes, Delete',
              cancelButtonText: 'Cancel',
              customClass: {
                confirmButton: 'swal2-delete'
              }
            });
          }}>Warning</Button>

          <Button variant="contained" onClick={() => {
            // Info/Reminder
            Swal.fire({
              icon: 'info',
              title: 'Reminder',
              text: 'To apply these changes, you\'ll need to refresh your preferences.',
              confirmButtonText: 'Update Settings'
            });
          }}>Info Reminder</Button>

          <Button variant="contained" onClick={() => {
            // Error
            Swal.fire({
              icon: 'error',
              title: 'Something went wrong?',
              text: 'We couldn\'t complete your request due to a server error. Please try again.',
              confirmButtonText: 'Retry'
            });
          }}>Error</Button>

          <Button variant="contained" onClick={() => {
            // Success
            Swal.fire({
              icon: 'success',
              title: 'Payment Successful!',
              text: 'Thank you! Your transaction is complete.',
              confirmButtonText: 'View Receipt'
            });
          }}>Success</Button>

          <Button variant="contained" onClick={() => {
            // Delete user with custom styling
            Swal.fire({
              title: 'Delete user?',
              html: 'Are you sure you want to delete <strong>this</strong> user?<br>Once deleted, all associated data will be permanently lost.',
              showCancelButton: false,
              confirmButtonText: 'Yes, Delete',
              customClass: {
                confirmButton: 'swal2-delete'
              }
            });
          }}>Delete User</Button>
        </Box> */}
        <CardContent
          sx={{
            p: 4,
            height: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            position: "relative",
            zIndex: 2,
          }}
        >
          <Box>
            <Typography
              variant="h4"
              sx={{
                color: "white",
                fontWeight: 600,
                mb: 1,
                fontSize: "2rem",
                lineHeight: 1.2,
                textTransform: 'capitalize'
              }}
            >
              {/* {t("welcomeBack")} 👋 */}
              {t("welcomeBack")} 👋
            </Typography>
            <Typography
              variant="h5"
              sx={{
                textTransform: 'capitalize',
                color: "white",
                fontWeight: 500,
                mb: 3,
                fontSize: "1.5rem",
              }}
            >
              {profile?.profile?.agent_name}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "rgba(255, 255, 255, 0.7)",
                mb: 4,
                fontSize: "1rem",
                lineHeight: 1.6,
                maxWidth: "280px",
              }}
            >
              {/* {t("tagline")} */}
              {t("tagline")}
            </Typography>
          </Box>

          {/* Character Illustration */}
          <Box
            sx={{
              position: "relative",
              marginLeft: "auto",
              zIndex: 1,
            }}
          >
            {getBadgeImage() && (
              <Box
                sx={{
                  width: 200,
                  height: 200,
                  background: `url(${getBadgeImage()})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }}
              />
            )}
          </Box>
        </CardContent>
      </Card>

      {/* Right Carousel Section */}
      <Card
        sx={{
          flex: 1,
          borderRadius: "20px",
          border: "none",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <Swiper
          modules={[Navigation, Pagination]}
          navigation={{
            prevEl: ".swiper-button-prev-custom",
            nextEl: ".swiper-button-next-custom",
          }}
          pagination={{
            clickable: true,
            bulletClass: "swiper-pagination-bullet-custom",
            bulletActiveClass: "swiper-pagination-bullet-active-custom",
            renderBullet: (index, className) => {
              return `<span class="${className}"></span>`;
            },
          }}
          spaceBetween={0}
          slidesPerView={1}
          style={{ height: "100%" }}
        >
          {slidesData.map((slide) => (
            <SwiperSlide
              key={slide.id}
              style={{
                userSelect: "none",
                background: lightMode ? "#ffffff" : "#343434",
              }}
            >
              {renderSlideContent(slide)}
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom Navigation Buttons */}
        <Box
          className="swiper-button-prev-custom"
          sx={{
            position: "absolute",
            top: 20,
            right: 60,
            zIndex: 10,
            width: 32,
            height: 32,
            borderRadius: "50%",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
            backdropFilter: "blur(10px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.3)",
              transform: "scale(1.1)",
            },
            "&::after": {
              content: '"❮"',
              color: "white",
              fontSize: "14px",
              fontWeight: "bold",
            },
          }}
        />

        <Box
          className="swiper-button-next-custom"
          sx={{
            position: "absolute",
            top: 20,
            right: 20,
            zIndex: 10,
            width: 32,
            height: 32,
            borderRadius: "50%",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
            backdropFilter: "blur(10px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.3)",
              transform: "scale(1.1)",
            },
            "&::after": {
              content: '"❯"',
              color: "white",
              fontSize: "14px",
              fontWeight: "bold",
            },
          }}
        />

        {/* Custom Pagination */}
        <Box
          sx={{
            position: "absolute",
            top: 20,
            left: 20,
            zIndex: 10,
            display: "flex",
            gap: 1,
            "& .swiper-pagination-bullet-custom": {
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.4)",
              cursor: "pointer",
              transition: "all 0.3s ease",
            },
            "& .swiper-pagination-bullet-active-custom": {
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              transform: "scale(1.2)",
            },
          }}
        />
      </Card>

      <style jsx global>{`
        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        .swiper-pagination {
          position: absolute !important;
          top: 20px !important;
          left: 20px !important;
          width: auto !important;
          display: flex !important;
          gap: 8px !important;
        }
      `}</style>
    </Box>
  );
};

export default SliderTopArea;
